import InfoPopper from './InfoPopper';
export default InfoPopper;
